import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';

@Component({
  selector: 'app-slide-toggle',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  animations: [
    trigger('slideIn', [
      state('void', style({ opacity: 0, transform: 'translateX(100%)' })),
      state('*',    style({ opacity: 1, transform: 'translateX(0)' })),
      transition(':enter', animate('300ms cubic-bezier(0.4,0,0.2,1)')),
      transition(':leave', animate('220ms cubic-bezier(0.4,0,0.2,1)')),
    ]),
  ],
})
export class SlideToggleComponent implements OnInit {
  @Input() label: string = 'Completed Tasks';
  @Input() isOpen: boolean = false;
  @Output() toggled = new EventEmitter<boolean>();

  // dragging
  isDragging = false;
  posY = 70;
  private dragStartY = 0;
  private dragStartPosY = 0;
  private readonly STORAGE_KEY = 'slt_posY';

  ngOnInit(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    if (saved) {
      this.posY = Math.max(54, parseInt(saved, 10));
    }
  }

  toggle(): void {
    if (!this.isDragging) {
      this.isOpen = !this.isOpen;
      this.toggled.emit(this.isOpen);
    }
  }

  onDragStart(e: MouseEvent | TouchEvent): void {
    e.preventDefault();
    this.isDragging = false;
    const clientY = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
    this.dragStartY = clientY;
    this.dragStartPosY = this.posY;

    const onMove = (ev: MouseEvent | TouchEvent) => {
      const y = ev instanceof MouseEvent ? ev.clientY : ev.touches[0].clientY;
      const delta = y - this.dragStartY;
      if (Math.abs(delta) > 4) this.isDragging = true;
      this.posY = Math.max(54, Math.min(window.innerHeight - 100, this.dragStartPosY + delta));
    };

    const onUp = () => {
      localStorage.setItem(this.STORAGE_KEY, String(this.posY));
      document.removeEventListener('mousemove', onMove as any);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove as any);
      document.removeEventListener('touchend', onUp);
      setTimeout(() => { this.isDragging = false; }, 50);
    };

    document.addEventListener('mousemove', onMove as any);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchmove', onMove as any, { passive: false });
    document.addEventListener('touchend', onUp);
  }
}
